const { cloneDeep, forEach } = require('lodash')

/**
 * CoreParams hozzaadasa ProcessListFilter api hivashoz
 *
 * @list string
 * @params $CORE.params
 * @return string
 */
const addCoreParams = function (list, params) {
  const amp = list.match(/\?/) ? '&' : '?' // @regex van-e a stringben kerdojel
  let coreParams = cloneDeep(params)
  // remove object duplicate of params
  forEach(coreParams, (value, key) => {
    if (typeof value === 'object') {
      delete coreParams[key]
    }
  })
  return `${list}${amp}dotoParams=${encodeURIComponent(JSON.stringify(coreParams))}`
}

export default addCoreParams
